var EnvName = 'clientdemo';
var key = {};
key.KEY = 'EDAFACENFTMarketPlace#%^09276!!'
key.EMAIL = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/
key.MOBILE = /^\d{10}$/
key.NumOnly = /[^0-9]/g
key.NumDigitOnly = /[^0-9\.]/g;
key.PASSWORD = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])(?!.*\s).{6,15}$/
key.notSpecil = /^[a-zA-Z0-9]+$/
key.nameFormat = /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|\ud83c[\ude32-\ude3a]|\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/g;

if (EnvName == "clientdemo") {
    key.FRONT_URL = 'https://sso.edaface.com'
    key.USER_BACK_URL = 'https://backend.edaface.com/v1/user'
    key.CHATURL = "https://backend.edaface.com/chat"
    key.Back_URL = "https://backend.edaface.com"
    key.Img_URL = "https://backend.edaface.com"
    key.cookiename = 'ssoToken'
    // key.domainname = "localhost"
    key.domainname = ".edaface.com"
}
else{
    key.FRONT_URL = 'http://localhost:3000'
    key.USER_BACK_URL = 'http://localhost:9376/v1/user'
    key.CHATURL = "http://localhost:9376/chat"
    key.Back_URL = "http://localhost:9376"
    key.Img_URL = "http://localhost:9376"
    key.cookiename = 'ssoToken'
    key.domainname = "localhost"
}

    

export default key;